'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
var $p;
/** @constructor */
function $c_Lpresto_TwoFactorAuthView$$anon$37() {
  this.bCJ = null;
  this.bCK = false;
}
export { $c_Lpresto_TwoFactorAuthView$$anon$37 as $c_Lpresto_TwoFactorAuthView$$anon$37 };
$p = $c_Lpresto_TwoFactorAuthView$$anon$37.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_TwoFactorAuthView$$anon$37;
/** @constructor */
function $h_Lpresto_TwoFactorAuthView$$anon$37() {
}
export { $h_Lpresto_TwoFactorAuthView$$anon$37 as $h_Lpresto_TwoFactorAuthView$$anon$37 };
$h_Lpresto_TwoFactorAuthView$$anon$37.prototype = $p;
$p.P = (function() {
  if ((!this.bCK)) {
    this.bCJ = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_T3($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_None$(), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_None$(), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_None$());
    this.bCK = true;
  }
  return this.bCJ;
});
var $d_Lpresto_TwoFactorAuthView$$anon$37 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_TwoFactorAuthView$$anon$37, "presto.TwoFactorAuthView$$anon$37", ({
  Sz: 1,
  a: 1,
  i: 1
}));
export { $d_Lpresto_TwoFactorAuthView$$anon$37 as $d_Lpresto_TwoFactorAuthView$$anon$37 };
//# sourceMappingURL=presto.-Two-Factor-Auth-View$$anon$37.js.map
